import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import Link from 'atoms/NextLink';
import { observer } from 'mobx-react-lite';
import Image from 'next/image';
import React, { useState } from 'react';
import { IResourceData } from 'utils/globalTypes';

import UnsubscribeFeed from '../UnsubscribeFeed';
import UnsubscribeForm from '../UnsubscribeForm';
import s from './UnsubscribeWrapper.module.scss';

interface UnsubscribeWrapperProps {
  images?: IResourceData[];
}

const UnsubscribeWrapper = ({ images }: UnsubscribeWrapperProps) => {
  const [subscribeEmail, setSubscribeEmail] = useState('');

  return (
    <div className={s.UnsubscribeWrapper}>
      <div className={s.UnsubscribeWrapper__containter}>
        <Image
          src="/svg/unsubscribe_visual.svg"
          alt="Unsubscribe visual"
          width={708}
          height={170}
        />

        <div className={s.UnsubscribeWrapper__content}>
          {subscribeEmail ? (
            <div className={s.UnsubscribeWrapper__reunsubscribe}>
              <Typography mb={2} variant="h2">
                Welcome back!
              </Typography>
              <Typography mb={1}>
                Your request to subscribe back <strong>[{subscribeEmail}]</strong> has been
                accepted.
              </Typography>
              <Typography mb={4}>
                Please allow up to 24 hours for the request to be processed.
              </Typography>
              <Link href="/marketplace">
                <a className={s.UnsubscribeWrapper__back}>
                  <ArrowBackIcon className={s.Error__backIcon} />
                  Go to Home page
                </a>
              </Link>
            </div>
          ) : (
            <UnsubscribeForm onResubscribe={(email) => setSubscribeEmail(email)} />
          )}
          {images && <UnsubscribeFeed className={s.UnsubscribeWrapper__feed} images={images} />}
        </div>
      </div>
    </div>
  );
};

export default observer(UnsubscribeWrapper);
